module.exports = __webpack_public_path__ + "assets/ic_check_s.654682be.svg";